/**
 * Helpers for asking workflow-type-level capability questions.
 *
 * `supportsBusinessImpact` returns true for ALL workflow types. The Impact
 * column's pencil/edit affordance and the expanded-row ImpactBlock should be
 * available everywhere so users can manually write an impact summary
 * regardless of workflow type.
 *
 * Note: automatic generation (the BI question stage + LLM trigger) is still
 * only wired up for Market Research and Services workflows — other workflow
 * types can only get an impact summary via manual edit. That is intentional
 * and gated elsewhere (not by this helper).
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function supportsBusinessImpact(
  _workflowType?: string | null
): boolean {
  return true;
}
